export default "__VITE_ASSET__DTox4xlT__"